import * as React from "react";

const FuelIconSVG = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill="#7C3AED"
            d="M11.75 29V13q0-.824.587-1.413A1.93 1.93 0 0 1 13.75 11h6q.824 0 1.413.587.587.588.587 1.413v7h1q.824 0 1.413.587.587.588.587 1.413v4.5q0 .424.288.712.287.288.712.288.424 0 .712-.288a.97.97 0 0 0 .288-.712v-7.2q-.225.124-.475.162a3.5 3.5 0 0 1-.525.038q-1.05 0-1.775-.725T23.25 17q0-.8.438-1.437.437-.639 1.162-.913l-2.1-2.1 1.05-1.05 3.7 3.6q.375.375.563.875T28.25 17v9.5q0 1.05-.725 1.775T25.75 29t-1.775-.725-.725-1.775v-5h-1.5V29zm2-11h6v-5h-6zm12 0q.424 0 .712-.287A.97.97 0 0 0 26.75 17a.97.97 0 0 0-.288-.713.97.97 0 0 0-.712-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713q0 .424.288.713.287.287.712.287m-12 9h6v-7h-6zm6 .038h-6z"
        ></path>
    </svg>
);

export default FuelIconSVG;
